import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {ResourceTypeList} from "../model/resourceTypeList";
import {ResourceTypeService} from "../service/resourceType.service";

@Injectable()
export class AllResourceTypesResolve implements Resolve<ResourceTypeList> {
    constructor(private resourceTypeService: ResourceTypeService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ResourceTypeList> {
        return this.resourceTypeService.getAll();
    }
}
